(() => {
  /**
   * Handle the collection meter and anims
   */
  class CollectMeter extends PIXI.Container {
    constructor() {
      super();
      this._toCollectTextValueAbove = null;
      this._toCollectTextValueDisplay = null;
      this._toCollectMeterPanel = null;
      this._allCollectedMeterPanel = null;
      this._textContainer = null;
      this._allCollected = false;

      // anims
      this._collectAnims = {};
      this._allCollectAnims = {};

      // anim positions
      this._animPositions = {
        default: { x: 1202, y: 232 },
        allCollected: { y: 172 },
      };

      this._devilLevelsBonusShow = {
        1: "boost",
        2: "multi",
        3: "respin",
      };

      this._colourSwitches = {
        boost: "Green",
        multi: "Blue",
        respin: "Red",
      };

      this._unlockedLevels = {
        boost: false,
        multi: false,
        respin: false,
      };

      this._currentMeterValue = null;

      this._currentDevilLevel = null;

      Reflex.registerEventHandler("orientationChange", this._orientationChange.bind(this));
    }

    /**
     * Initialise the class
     */
    initialise() {
      // Text value
      this._textContainer = resourceManager.get(`${this.name}:toCollectMeter:textContainer`);
      this._toCollectTextValueAbove = resourceManager.get(
        `${this.name}:toCollectMeter:textContainer:toCollectTextAbove`
      );
      this._toCollectTextValueDisplay = resourceManager.get(
        `${this.name}:toCollectMeter:textContainer:toCollectTextDisplay`
      );
      this._toCollectMeterPanel = resourceManager.get(`${this.name}:toCollectMeter`);
      this._allCollectedMeterPanel = resourceManager.get(`${this.name}:allCollectedMeter`);

      this._greyTexts = {};
      this._greyTexts.boost = resourceManager.get(`${this.name}:allCollectedMeter:boostGrey`);
      this._greyTexts.multi = resourceManager.get(`${this.name}:allCollectedMeter:multiGrey`);
      this._greyTexts.respin = resourceManager.get(`${this.name}:allCollectedMeter:respinGrey`);
      this._activatedText = resourceManager.get(`${this.name}:allCollectedMeter:activated`);

      let lang = gdk.getCurrentLanguage();

      if (lang === "en-GB") {
        resourceManager.get(`${this.name}:toCollectMeter:moreDevilsTextEN`).visible = true;
        resourceManager.get(`${this.name}:toCollectMeter:moreDevilsText`).visible = false;
      } else {
        resourceManager.get(`${this.name}:toCollectMeter:moreDevilsTextEN`).visible = false;
        resourceManager.get(`${this.name}:toCollectMeter:moreDevilsText`).visible = true;
      }

      Object.values(this._greyTexts).forEach((text) => {
        text.alpha = 0.5;
        text.visible = false;
      });

      //TO COLLECT ANIMS

      // BOOST BONUS ANIM
      this._collectAnims.boost = resourceManager.createObject("movie", "collectBoostAnim", this._toCollectMeterPanel, {
        definition: "collectBoostBonus",
        x: 0,
        y: 65,
        anchor: 0.5,
        scale: 0.45,
        loop: false,
      });

      // MULTIBONUS ANIM
      this._collectAnims.multi = resourceManager.createObject("movie", "collectMultiAnim", this._toCollectMeterPanel, {
        definition: "collectMultiBonus",
        x: 0,
        y: 65,
        anchor: 0.5,
        scale: 0.45,
        loop: false,
      });

      // RESPIN BONUS ANIM
      this._collectAnims.respin = resourceManager.createObject(
        "movie",
        "collectRespinAnim",
        this._toCollectMeterPanel,
        {
          definition: "collectRespinBonus",
          x: 0,
          y: 65,
          anchor: 0.5,
          scale: 0.45,
          loop: false,
        }
      );

      //ALL COLLECT ANIMS

      // BOOST BONUS ANIM
      this._allCollectAnims.boost = resourceManager.createObject(
        "movie",
        "collectBoostAnimAll",
        this._allCollectedMeterPanel,
        {
          definition: "collectBoostBonus",
          x: 0,
          y: -62,
          anchor: 0.5,
          scale: 0.35,
          loop: false,
        }
      );
      // MULTIBONUS ANIM
      this._allCollectAnims.multi = resourceManager.createObject(
        "movie",
        "collectMultiAnimAll",
        this._allCollectedMeterPanel,
        {
          definition: "collectMultiBonus",
          x: 0,
          y: -7,
          anchor: 0.5,
          scale: 0.35,
          loop: false,
        }
      );
      // RESPIN BONUS ANIM
      this._allCollectAnims.respin = resourceManager.createObject(
        "movie",
        "collectRespinAnimAll",
        this._allCollectedMeterPanel,
        {
          definition: "collectRespinBonus",
          x: 0,
          y: 48,
          anchor: 0.5,
          scale: 0.35,
          loop: false,
        }
      );

      Object.values(this._collectAnims).forEach((anim) => {
        anim.gotoAndStop(0);
        anim.visible = false;
        anim.onComplete = () => {
          anim.gotoAndStop(0);
        };
      });

      Object.values(this._allCollectAnims).forEach((anim) => {
        anim.gotoAndStop(0);
        anim.onComplete = () => {
          anim.gotoAndStop(0);
        };
      });

      this.setBonusType("boost");
      this.setMask();
    }

    /**
     * Shows/hides panel with all collected devils, greys non-collected ones
     * @param show
     */
    toggleFreeSpinsMeter(show, buyBonus) {
      if (show) {
        const level = buyBonus ? 4 : this._currentDevilLevel;

        this._allCollectedMeterPanel.visible = true;

        this._activatedText.alpha = 1;

        Object.values(this._allCollectAnims).forEach((text) => {
          text.visible = false;
        });
        Object.values(this._greyTexts).forEach((text) => {
          text.visible = true;
        });

        switch (level) {
          case 1:
            this._activatedText.alpha = 0.5;
            break;
          case 2:
            this._allCollectAnims.boost.visible = true;
            this._greyTexts.boost.visible = false;
            break;
          case 3:
            this._greyTexts.boost.visible = false;
            this._greyTexts.multi.visible = false;
            this._allCollectAnims.boost.visible = true;
            this._allCollectAnims.multi.visible = true;
            break;
          case 4:
            Object.values(this._allCollectAnims).forEach((text) => {
              text.visible = true;
            });
            Object.values(this._greyTexts).forEach((text) => {
              text.visible = false;
            });
            break;
        }
      } else {
        this._allCollectedMeterPanel.visible = this._allCollected;
        this._activatedText.alpha = 1;

        Object.values(this._allCollectAnims).forEach((text) => {
          text.visible = true;
        });
        Object.values(this._greyTexts).forEach((text) => {
          text.visible = false;
        });
      }
    }

    /**
     * Set the mask for the collect value
     */
    setMask() {
      const mask = new PIXI.Graphics();
      mask.beginFill(0xffffff);
      mask.drawRect(0, 0, 100, 69);
      mask.endFill();

      mask.position.set(-50, -90);

      this._textContainer.addChild(mask);
      this._textContainer.mask = mask;
    }

    /**
     * Set to collect text value
     * @param {Number} value - To collect text value
     */
    setToCollectTextValue(value) {
      this._toCollectTextValueAbove.text = value === 0 ? 10 : value - 1;
      this._toCollectTextValueDisplay.text = value;

      this._currentMeterValue = value;
    }

    /**
     * Set whether all collected or not
     * @param {boolean} allCollected - set allCollected or not
     */
    setAllCollected(allCollected) {
      this._allCollected = allCollected;
      this._allCollectedMeterPanel.visible = allCollected;
      this._toCollectMeterPanel.visible = !allCollected;
    }

    /**
     * Set bonus type for the meter
     * @param {String} bonusType - 'boost', 'multi', 'respin
     */
    setBonusType(bonusType) {
      Object.values(this._collectAnims).forEach((anim) => {
        anim.visible = false;
        anim.alpha = 1;
      });
      this._collectAnims[bonusType].visible = true;
    }

    /**
     * Pulse the text
     */
    idleTextAnim() {
      if (this._idleTween) this._idleTween.kill();

      if (this._allCollected) {
        const tl = gsap.timeline();
        const interval = 0.1;
        let index = 0;

        Object.values(this._allCollectAnims).forEach((anim) => {
          anim.gotoAndPlay(0);

          const startTime = index * interval;

          tl.fromTo(
            anim,
            {
              pixi: { scaleX: 0.35, scaleY: 0.35 },
            },
            {
              duration: 0.5,
              pixi: { scaleX: 0.38, scaleY: 0.38 },
              repeat: 1,
              yoyo: true,
              ease: "power1.inOut",
            },
            startTime
          );

          index++;
        });
      } else {
        const tl = gsap.timeline();
        const interval = 0.1;
        let index = 0;

        Object.values(this._collectAnims).forEach((anim) => {
          anim.gotoAndPlay(0);

          const startTime = index * interval;

          tl.fromTo(
            anim,
            {
              pixi: { scaleX: 0.45, scaleY: 0.45 },
            },
            {
              duration: 0.5,
              pixi: { scaleX: 0.48, scaleY: 0.48 },
              repeat: 1,
              yoyo: true,
              ease: "power1.inOut",
            },
            startTime
          );

          index++;
        });
      }
    }

    /**
     * Animate the meter value after devil collect
     */
    async animateMeterValue(devilProgress) {
      const { level: devilLevel, nextUpgradeCount } = devilProgress;

      const texts = [this._toCollectTextValueAbove, this._toCollectTextValueDisplay];

      await gsap.to(texts, { y: "+=65", duration: 1 });

      let pulseTween;
      let assetToTween;
      // if zero unlock the next modifier
      if (devilLevel !== this._currentDevilLevel) {
        this._toCollectTextValueDisplay.y -= 130;
        this._toCollectTextValueDisplay.text = nextUpgradeCount;

        const currentModifierShowing = this._devilLevelsBonusShow[this._currentDevilLevel];

        assetToTween = this._collectAnims[currentModifierShowing];

        const scaleReset = assetToTween.scale.x;
        pulseTween = gsap.to(assetToTween.scale, {
          x: 0.5,
          y: 0.5,
          yoyo: true,
          repeat: -1,
          ease: "power1.inOut",
          duration: 0.2,
        });

        await new Promise((res) => gsap.delayedCall(0.5, res));

        gameController.reelBorderFire.switchColour(this._colourSwitches[currentModifierShowing]);

        await gameController.modifierAwardedPanel.awardBonus(currentModifierShowing);

        pulseTween.kill();

        if (devilLevel === 4) {
          this.setAllCollected(true);
        } else {
          await gsap.to(assetToTween.scale, { x: 0, y: 0, duration: 0.3 });
          const nextModifierShowing = this._devilLevelsBonusShow[devilLevel];
          const nextModifierAsset = this._collectAnims[nextModifierShowing];
          gsap.fromTo(nextModifierAsset.scale, { x: 0, y: 0 }, { x: scaleReset, y: scaleReset, duration: 0.5 });
          nextModifierAsset.visible = true;
          await gsap.to(texts, { y: "+=65", duration: 1 });
        }

        assetToTween.scale.set(scaleReset);
        assetToTween.visible = false;
        this._currentDevilLevel = devilLevel;

        this._unlockedLevels[currentModifierShowing] = true;
      }

      this.setToCollectTextValue(nextUpgradeCount);
      this._toCollectTextValueAbove.y = -120;
      this._toCollectTextValueDisplay.y = -55;
    }

    /**
     * set initial state of collect meter
     */
    setInitialState({ devilLevel, nextDevilCount }) {
      if (devilLevel === 4) {
        this.setAllCollected(true);
        this._unlockedLevels.boost = true;
        this._unlockedLevels.multi = true;
        this._unlockedLevels.respin = true;
      } else {
        this.setAllCollected(false);
        this.setToCollectTextValue(nextDevilCount);
        this.setBonusType(this._devilLevelsBonusShow[devilLevel]);

        for (let i = 1; i < devilLevel; i++) {
          const unlockedMod = this._devilLevelsBonusShow[i];
          this._unlockedLevels[unlockedMod] = true;
        }
      }
      this._currentDevilLevel = devilLevel;
    }

    /**
     * Get the currently unlocked modifiers
     */
    getCurrentUnlockedModifiers() {
      if (gameController.inBuyABonus) {
        return Object.entries(this._unlockedLevels).map(([key, value]) => key);
      } else {
        return Object.entries(this._unlockedLevels)
          .filter(([key, value]) => value === true)
          .map(([key]) => key);
      }
    }

    get currentDevilLevel() {
      return this._currentDevilLevel;
    }

    /**
     * Handle orientation change
     * @param {boolean} isLandscape
     */
    _orientationChange(isLandscape) {}
  }

  resourceManager.registerObjectType(
    "collectMeter",
    () => new CollectMeter(),
    () => {},
    () => []
  );
})();
